import React from 'react';

const HelpContents = ({lang}) => {
  switch (lang) {
  case 'fi':
    return (
      <div>
        <h2>Kansion metatietopohjan muokkaaminen</h2>
        <p>Tämän toiminnon avulla voit muokata kansiokohtaista metatietopohjaa. 
        Kun kansiolle on luotu metatietopohja, järjestelmä antaa automaattisesti kaikille 
        kansioon lisättäville kohteille pohjaan määritetyt metatiedot. 
        Tiedot eivät päivity kansioon jo aiemmin lisättyisiin kohteisiin. Ks. Useiden 
        objektien metatiedon muokkaaminen kerralla. </p> 
        <p>Mikäli kansiossa voi olla usean tyyppisiä kohteita, näkyvät tässä vain kaikille niille yhteiset kentät.</p>
      </div>
    );
    
  case 'en':
    return (
      <div>
        <h2>Editing folder metadata template</h2>
        <p>Use this feature to edit the folder specific metadata template.
        When a metadata template is created for a folder, the system automatically assigns the specified metadata
        to the items that are added to folder.
        The information is not updated in the items already added to the folder.
        See Editing multipl metadata of multiple objects at once. </p>
        <p>If there are several types of items in the folder, only the fields that are common to them will appear here.</p>
      </div>
    );

  case 'sv':
    return (
      <div>
        <h2>Redigering av en mapps metadatamall</h2>
        <p>Använd den här funktionen för att redigera den mappspecifika metadatabasen.
        När en metadatabase skapas för en mapp, ger systemet automatiskt
        fördefinierad metadata för de objekt som ska läggas till i mappen.
        Informationen är inte uppdaterad i de föremål som redan har lagts till i mappen. Se 'Redigering metadata av
        flera objekt samtidigt'. </p>
        <p>Om det kan finnas flera typer av objekt i mappen visas bara de fält som är gemensamma för dem här.</p>
      </div>
    );
  }

  return <p>Error</p>;
};

export default HelpContents;